export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fileList.vue?vue&type=template&id=1e720148&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/fileList.vue?vue&type=template&id=1e720148&scoped=true&
// module id = null
// module chunks = 